import EmailShow from './EmailShow';

export default {
	show: EmailShow
}